import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=e2091776"
import script from "@/components/curriculum/Curriculum.ts?vue&type=script&lang=ts&external"
export * from "@/components/curriculum/Curriculum.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/curriculum/curriculum.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports